import { lt } from './lt';
import { en } from './en';

export const translations = {
  lt,
  en,
};

export type TranslationKey = keyof typeof lt;
